import React from "react";
import { logger } from "@/functions/logger";

/**
 * Top-level React error boundary. Catches render/lifecycle errors that would
 * otherwise white-screen the app, records them to the audit log, and shows a
 * minimal recovery UI. The user may reload before the next sync, so we flush().
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logger.error("app.crashed", "React render error", {
      context: {
        error: error?.message,
        stack: error?.stack,
        component_stack: info?.componentStack,
      },
    });
    logger.flush();
  }

  handleReload = () => {
    window.location.reload();
  };

  // Reloading keeps the crashing URL, so a route that throws on first render re-crashes on every
  // reload. Leaving for the dashboard (full load, fresh in-memory state) breaks that loop.
  handleGoHome = () => {
    window.location.assign("/dashboard");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mt-5 text-center">
          <h4>Algo salió mal</h4>
          <p>Ocurrió un error inesperado. Por favor recargue la aplicación.</p>
          <button className="btn btn-primary mt-3" onClick={this.handleReload}>
            Recargar
          </button>
          <div>
            <button className="btn btn-link mt-2" onClick={this.handleGoHome}>
              Ir al inicio
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
